export const UPDATE_DEAL_LIFE_CYCLE_REQUEST = 'UPDATE_DEAL_LIFE_CYCLE_REQUEST';
export const UPDATE_DEAL_LIFE_CYCLE_SUCCESS = 'UPDATE_DEAL_LIFE_CYCLE_SUCCESS';
export const UPDATE_DEAL_LIFE_CYCLE_FAILURE = 'UPDATE_DEAL_LIFE_CYCLE_FAILURE';
export const UPDATE_DEAL_LIFE_CYCLE_READY = 'UPDATE_DEAL_LIFE_CYCLE_READY';
export const SHOW_DEAL_LIFE_CYCLE_MODAL = 'SHOW_DEAL_LIFE_CYCLE_MODAL';
export const SET_DEAL_LIFE_CYCLE_MODAL_LOADER = 'SET_DEAL_LIFE_CYCLE_MODAL_LOADER';
